module.exports = __webpack_public_path__ + "static/media/vod37.b4513655.png";